import React from 'react';
import classnames from 'classnames';

import { CollaboratorAvatar, Button } from 'components';
import { AuditIcon } from 'screens/AuditScreens';
import Icon from 'assets/icons';

import styles from './AccessListItem.module.scss';

interface AccessListItemPersonProps {
  person: any;
  buttonMessage?: string;
  showIntegrations?: boolean;
  type?: string;
  isOutsideOwner?: boolean
}

export const AccessListItemPerson = ({
  person,
  buttonMessage,
  type,
  showIntegrations = false,
  isOutsideOwner
}: AccessListItemPersonProps) => {
  const integrationName = person?.integrations[0]?.title || 'Integration';
  const integrationType =
    person?.integrations[0]?.type?.slice(0, person?.integrations[0]?.type?.indexOf('@')) || '';

  return (
    <div
      className={classnames(styles.container, styles.person, {
        [styles[`type--${type}`]]: type,
      })}
    >
      <CollaboratorAvatar
        bordered={false}
        className={styles.avatar}
        size={type === 'Full' ? 'XXL' : 'Medium'}
        collaborator={{
          displayName: person?.name || '',
          emailAddress: person?.email || '',
          photoURL: person?.avatarUrl || '',
        }}
      />
      <div className={styles.dataContainer}>
        <div className={styles.title}>{person?.name}</div>
        <div className={styles.meta}>{person?.email}</div>
        {showIntegrations && person?.integrations[0] && (
          <div className={styles.meta}>
            <NoOfDocuments length={person?.integrations[0]?.integrationNodes?.pageInfo?.total.toLocaleString()} />
            {/* <>{person?.integrations[0]?.integrationNodes?.pageInfo?.total + ' documents in '}</> */}
            <AuditIcon className={styles.documentIcon} itemIntegrationName={integrationType} />
            {integrationName && integrationName}
            <>
              {person?.integrations?.length > 1 ? (
                <OtherServices length={person.integrations.length} />
              ) : null}
            </>
          </div>
        )}
      </div>
      <div className={styles.CTA}>
        <Button size={'Medium'} type="Cancel" disabled>
          {buttonMessage}
          {isOutsideOwner && (
            <Icon.OpenAll className={styles.CTA__icon} />
          )}  
        </Button>
      </div>
    </div>
  );
};

const NoOfDocuments = ({ length }: any) => {
  if (length === 1) {
    return <>{' 1 document in '}</>;
  } else {
    return <>{length + ' documents in '}</>;
  }
};

const OtherServices = ({ length }: any) => {
  if (length === 2) {
    return <>{' and 1 other service'}</>;
  } else {
    return <>{' and ' + (length - 1) + ' other services'}</>;
  }
};
